export const trending = [
  { rank: 1, title: "五一假期调休方案讨论", category: "社交热点", heat: 9820, tag: "沸" },
  { rank: 2, title: "音乐节现场秩序与退票话题", category: "娱乐动态", heat: 9140, tag: "热" },
  { rank: 3, title: "景区门票与酒店价格对比", category: "出行消费", heat: 8760, tag: "热" },
  { rank: 4, title: "五一档影片口碑分化", category: "影视综", heat: 8230, tag: "热" },
  { rank: 5, title: "品牌节日文案争议", category: "品牌营销", heat: 7740, tag: "新" },
  { rank: 6, title: "返程高峰高速免费时段", category: "出行消费", heat: 7310, tag: "新" },
  { rank: 7, title: "短剧与长剧的假期收视对比", category: "影视综", heat: 6890, tag: "新" },
  { rank: 8, title: "演唱会抢票与实名入场", category: "娱乐动态", heat: 6420, tag: "新" },
  { rank: 9, title: "探店内容真实性讨论", category: "社交热点", heat: 5980, tag: "议" },
  { rank: 10, title: "假期消费券与促销规则", category: "品牌营销", heat: 5530, tag: "议" },
];

export const quickStats = [
  { label: "本期收录事件", value: "68", unit: "条" },
  { label: "覆盖话题", value: "142", unit: "个" },
  { label: "时间线跨度", value: "8", unit: "天" },
  { label: "整理盘点长文", value: "9", unit: "篇" },
];